import React from 'react';
import './CompositeFillingContent.css'; // Assuming you have a CSS file for styling

/* Reusing the same CSS file as CompositeFillingContent */
const FixedBridgesContent = () => {
  return (
    <div className="composite-fillings">
      <div className="composite-fillings-overview-container">
          <div className="composite-fillings-overview-info">
            <h2 className="composite-fillings-overview-header">Fixed Bridges</h2>
            <div className="composite-fillings-custom-line"></div>
            <p className="composite-fillings-text">A dental bridge is a fixed (non-removable) appliance and is an excellent way to replace missing teeth.</p>
            <p className="composite-fillings-text">There are several types of bridges.  You and your dentist will discuss the best options for your particular case.  The “traditional bridge” is the most popular type and is usually made of porcelain fused to metal.  This type of bridge consists to two crowns that go over two anchoring teeth (abutment teeth) and are attached to pontics (artificial teeth), filling the gap created by one or more missing teeth.</p>
            <p className="composite-fillings-text">Dental bridges are highly durable and will last many years, however they may need replacement or need to be re-cemented due to normal wear.</p>
          </div>

          <div className="composite-fillings-image-container">
            <img 
              src="/images/fixed-bridges.jpeg"
              alt="Porcelain Crowns" 
              className="composite-fillings-1"
            />
          </div>
      </div>

      <div className="composite-fillings-description-container">
        <div className="composite-fillings-reasons-container">
          <h3 className="composite-fillings-reasons-header">Reasons for a Fixed Bridge:</h3>
          <ul className="composite-fillings-reasons-list">
            <li>Fill space of missing teeth</li>
            <li>Maintain facial shape</li>
            <li>Prevent remaining teeth from drifting out of position</li>
            <li>Restore chewing and speaking ability.</li>
            <li>Restore your smile</li>
            <li>Upgrade from a removable partial denture to a permanent dental appliance</li>
          </ul>
        </div>

        <div className="composite-fillings-steps-container">
          <h3 className="composite-fillings-steps-header">What does getting a fixed bridge involve?</h3>
          <p className="composite-fillings-steps-text">Getting a bridge usually requires two or more visits.  While the teeth are numb, the two anchoring teeth are prepared by removing a portion of enamel to allow for a crown.  Next, a highly accurate impression (mold) is made which will be sent to a dental laboratory where the bridge will be fabricated.  In addition, a temporary bridge will be made and worn for several weeks until your next appointment.</p>
          <p className="composite-fillings-steps-text">At the second visit, you permanent bridge will be carefully checked, adjusted, and cemented to achieve a proper fit.  Occasionally your dentist may only temporarily cement the bridge, allowing your teeth and tissue time to get used to the new bridge.  The new bridge will be permanently cemented at a later time.</p>
          <p className="composite-fillings-steps-text">You will receive care instructions at the conclusion of the procedure.  Proper brushing, flossing and regular dental visits will aid in the life of your new permanent bridge!</p>
        </div>

      </div>
    </div>
  );
};

export default FixedBridgesContent;